import { ORDER_STATUS } from '@/shared/config/order-status';
import { HttpClient } from '@/shared/lib/http-client';

export const fetchConcludedOrders = async () => {
  const FIRST_PAGE = 1;
  const ITEMS_PER_PAGE = 5;

  const TYPE_ID_OSAGO = 1;
  const TYPE_ID_BUS = 2;
  const TYPE_ID_GREEN_CARD = 3;
  const TYPE_ID_TOURISM = 5;
  const TYPE_ID_MANUAL = 7;
  const TYPE_ID_HOME = 8;
  const TYPE_ID_PETS = 9;

  const response = await HttpClient.post('/orders/order-statistics', {
    typeId: [TYPE_ID_OSAGO, TYPE_ID_BUS, TYPE_ID_GREEN_CARD, TYPE_ID_TOURISM, TYPE_ID_MANUAL, TYPE_ID_HOME, TYPE_ID_PETS],
    statusId: ORDER_STATUS.ORDER_STATUS_CONCLUDED,
    page: FIRST_PAGE,
    limit: ITEMS_PER_PAGE,
  });

  return response.data?.data;
};
